import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { UtilidadesService } from '../utilidades.servicios.index';

@Directive({
	selector: '[permiso]'
})
export class PermisoDirective {

	private Estado: string = "";

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private Utilidades: UtilidadesService
	) {
		this.Utilidades._menuActualizado.subscribe(() => {
			this.TienePermiso();
		});
	}

	@Input() set permiso(permiso: string) {
		this.Estado = permiso;
		this.TienePermiso();
	}

	TienePermiso(): void {
		if (this.Utilidades.TienePermiso(this.Estado)) {
			//Si la condición es TRUE agrego la plantilla al DOM.
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			//Si no quito la plantilla del DOM
			this.viewContainer.clear();
		}
	}
}